import {
  GET_USER_DETAILS_BY_USER_ID_LOADING,
  GET_USER_DETAILS_BY_USER_ID_SUCCESS,
  GET_USER_DETAILS_BY_USER_ID_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listSingleItemService } from "services/listSingleItemService";

export const getUserProfileDetailsActions =
  (userId?: any, callback?: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: GET_USER_DETAILS_BY_USER_ID_LOADING, payload: true });

      const response: any = await listSingleItemService(
        `/account/v1/web/user-details/${userId}`,
        ""
      );

      dispatch({
        type: GET_USER_DETAILS_BY_USER_ID_SUCCESS,
        payload: response.data,
      });
    } catch (err) {
      dispatch({ type: GET_USER_DETAILS_BY_USER_ID_FAILURE, payload: err });
    } finally {
      dispatch({ type: GET_USER_DETAILS_BY_USER_ID_LOADING, payload: false });
    }
  };
